import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useTranslation, Trans } from 'react-i18next';
import { Link } from 'react-router-dom';

import ArtTrackOutlinedIcon from '@mui/icons-material/ArtTrackOutlined'
import BannerRotatorButton from './BannerRotatorButton'
import CategoryOutlinedIcon from '@mui/icons-material/CategoryOutlined'
import LandingsButton from './LandingsButton'
import LoyaltyOutlinedIcon from '@mui/icons-material/LoyaltyOutlined'
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined'
import ViewCarouselOutlinedIcon from '@mui/icons-material/ViewCarouselOutlined'
import ViewDayOutlinedIcon from '@mui/icons-material/ViewDayOutlined'
import WidgetsOutlinedIcon from '@mui/icons-material/WidgetsOutlined';

import Alert from 'cityads-v3/components/Dialog/Alert';
import FiranoIcon from 'cityads-v3/components/Icons/FiranoIcon';
import SupportButton from 'cityads-v3/components/Buttons/SupportButton';

import {
  COUPON_STATUS_ID_ACTIVE,

  TOOL_ID_LANDING,
  TOOL_ID_BANNERS,
  TOOL_ID_BANNER_ROTATOR,
  TOOL_ID_COUPONS,
  TOOL_ID_GOODS_FEED,
  TOOL_ID_GOODS,
  TOOL_ID_FINANCE_API,
  TOOL_ID_WIDGETS,
} from 'cityads-v3/reducers/offers';

import classes from './Tools.scss';

function getToolParameters(offerId, enabled, loggedIn, subscribed, requested, hasOrd, id) {
  if (!enabled) {
    return {
      Component: 'div',
    };
  }

  if (!loggedIn) {
    return {
      Component: Link,
      to: `/publisher/offer/${offerId}/tools/register/publisher`,
    };
  }

  if (!subscribed) {
    if (!requested) {
      return {
        Component: Link,
        to: `/publisher/offer/${offerId}/request/`,
      };
    }

    return {
      Component: 'div',
    };
  }

  switch (id) {
    case TOOL_ID_FINANCE_API:
      return {
        Component: Link,
        to: `/publisher/firano`,
      };
    case TOOL_ID_COUPONS:
      const couponFilter = {
        coupon_offer: [offerId],
        coupon_status: [String(COUPON_STATUS_ID_ACTIVE)]
      };

      return {
        Component: Link,
        to: `/publisher/coupons?filter=${JSON.stringify(couponFilter)}`,
      };
    case TOOL_ID_WIDGETS:
      return {
        Component: Link,
        to: `/publisher/tools/widgets`,
      };
    case TOOL_ID_GOODS:
      return {
        Component: 'a',
        href: `/webmaster/products_and_coupons/products/catalog_403319272.0.htm?offer[]=${offerId}`,
      };
    case TOOL_ID_BANNERS:
      if (hasOrd) {
        return {
          Component: BannerDenied,
        };
      } else {
        return {
          Component: 'a',
          href: `/webmaster/offers/web/?id=${offerId}.5#page-3`,
        };
      }
    case TOOL_ID_LANDING:
      return {
        Component: LandingsButton,
        offerId: +offerId
      };
    case TOOL_ID_GOODS_FEED:
      return {
        Component: 'a',
        href: `/webmaster/offers/web/?id=${offerId}.5#page-3`,
      };
    case TOOL_ID_BANNER_ROTATOR:
      return {
        Component: BannerRotatorButton,
        offerId: +offerId
      };
    default:
      return {
        Component: 'div',
      };
  }
};

function getIcon(code) {
  switch (code) {
    case TOOL_ID_FINANCE_API:
      return FiranoIcon;
    case TOOL_ID_COUPONS:
      return LoyaltyOutlinedIcon;
    case TOOL_ID_WIDGETS:
      return WidgetsOutlinedIcon;
    case TOOL_ID_GOODS:
      return CategoryOutlinedIcon;
    case TOOL_ID_BANNERS:
      return ViewDayOutlinedIcon;
    case TOOL_ID_LANDING:
      return ArtTrackOutlinedIcon;
    case TOOL_ID_GOODS_FEED:
      return ShoppingCartOutlinedIcon;
    case TOOL_ID_BANNER_ROTATOR:
      return ViewCarouselOutlinedIcon;
    default:
      return null;
  }
}

export default function ToolButton({ offerId, enabled, loggedIn, subscribed, requested, hasOrd, name, id }) {
  const { Component, ...params } = getToolParameters(offerId, enabled, loggedIn, subscribed, requested, hasOrd, id);
  const Icon = getIcon(id);

  return (
    <Component {...params} className={classNames(classes.button, { [classes.enabledButton]: enabled })}>
      {Icon ? <Icon className={classes.buttonIcon} /> : null}
      <span className={classes.buttonText}>
        {name}
      </span>
    </Component>
  );
}

ToolButton.propTypes = {
  offerId   : PropTypes.number.isRequired,
  enabled   : PropTypes.bool,
  loggedIn  : PropTypes.bool,
  subscribed: PropTypes.bool,
  requested : PropTypes.bool,
  hasOrd    : PropTypes.bool,

  name: PropTypes.string,
  id  : PropTypes.number,
};


function BannerDenied({ children, ...rest }) {
  const { t } = useTranslation(['Offers']);
  const [open, setOpen] = useState(false);

  return (
    <>
      <button type="button" {...rest} onClick={() => setOpen(true)}>
        {children}
      </button>
      <Alert open={open} onClose={() => setOpen(false)} title={t('ordBannersMessageTitle')}>
        <Trans t={t} i18nKey="ordBannersMessage">
          If you want to use this advertiser's banners, please, contact your personal manager or
          <SupportButton component="a" className={classes.supportLink}>the technical support</SupportButton>.
        </Trans>
      </Alert>
    </>
  );
}
